
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export const TypingIndicator = () => {
  return (
    <div className="flex items-start gap-3 max-w-[95%] mr-auto">
      <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0.5 }}
          animate={{ opacity: 1 }}
          transition={{ repeat: Infinity, duration: 0.8, repeatType: "reverse" }}
          className="h-5 w-5 rounded-full bg-primary/20 flex items-center justify-center"
        />
      </div>
      <div className={cn(
        "rounded-lg px-4 py-3 bg-muted flex items-center"
      )}>
        <div className="flex space-x-1">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              initial={{ y: 0 }}
              animate={{ y: [0, -5, 0] }}
              transition={{
                duration: 0.6,
                repeat: Infinity,
                delay: i * 0.1,
              }}
              className="h-2 w-2 rounded-full bg-muted-foreground/40"
            />
          ))}
        </div>
      </div>
    </div>
  );
};
